import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Prebuilt Font Awesome CSS — Vite resolves and bundles the bundled webfonts,
// so no manual copying into public/ is needed.
import '@fortawesome/fontawesome-free/css/all.min.css';
import './scss/index.scss';
import App from './App.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the PWA service worker (offline shell). Dev (Vite HMR) skips it to
// avoid caching the module graph; production serves /sw.js from build/.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* registration is best-effort; app still works without it */
    });
  });
}
